import { List, RadioGroup } from "@mui/material";

import BoatListItem from "./BoatListItem";

import { Props } from "@/types/users";
import { TVessel } from "@/types/vessel";

function BoatList({ vessels, onEditOpenModal, onChangeBoat }: Props) {
  return (
    <RadioGroup
      aria-labelledby="radio settings"
      name="boat-settings"
      value={vessels.find((v: TVessel) => v.current)?.id}
    >
      <List>
        {vessels.map((vessel: TVessel) => (
          <BoatListItem
            key={vessel.id}
            vessel={vessel}
            onChangeBoat={onChangeBoat}
            onEditOpenModal={onEditOpenModal}
          />
        ))}
      </List>
    </RadioGroup>
  );
}

export default BoatList;
